import React, { useEffect, useState } from 'react';
import { usePrevious } from 'react-use';
import { connect } from 'react-redux';
import config from '../../config';

import './EventTable.scss';

const EventTable = (props) => {
  const { i18n } = props;
  const { locale } = i18n || {};

  const headline = props.title || '';
  const { url } = props;

  const [loadedLib, setLoadedLib] = useState(false);

  const loadScripts = (array, callback) => {
    const loader = function loader(src, handler) {
      const script = document.createElement('script');
      script.src = src;

      script.onload = script.onreadystatechange = function () {
        script.onreadystatechange = script.onload = null;
        handler();
      };

      const head = document.getElementsByTagName('head')[0];
      (head || document.body).appendChild(script);
    };

    (function run() {
      if (array.length !== 0) {
        loader(array.shift(), run);
      } else {
        callback && callback();
      }
    })();
  };

  const initUI = (lang) => {
    window.eventUI.init({
      ...config.eventTable,
      language: lang,
      container: 'eventWidget',
      api: config.eventTableAPI,
    });
  };

  useEffect(() => {
    loadScripts([config.eventTablePolyFill, config.eventTableJSLib], function () {
      setLoadedLib(true);
      initUI(locale);
    });
    document
      .getElementsByTagName('head')[0]
      .insertAdjacentHTML('beforeend', `<link rel="stylesheet" href="${config.eventTableCSS}">`);
  }, []);

  const prevLocale = usePrevious(locale);
  useEffect(() => {
    if (!locale) return;

    if (locale !== prevLocale && loadedLib) {
      initUI(locale);
    }
  }, [locale]);

  const moreButton = (
    <div className="child-more-item">
      <div className="item-more">
        <a target="_blank" className="button button--ghost-orange" href={url}>
          <span>Continua</span>
        </a>
      </div>
    </div>
  );

  const headlineEle = <>{headline && <div className="eventTable__title">{headline}</div>}</>;

  return (
    <>
      <section className="container section-mainPage-eventTable">
        {headlineEle}
        <div id="eventWidget" />
        {moreButton}
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(EventTable);

export { EventTable as EventTableComponent }; // <- For component Unit Test
export default connectStore;
